import { fmtDateTime } from '@/lib/format'
import { PersonName } from '@/components/PersonName'
import type { TemplateDetail } from '@/lib/scientific'

/** Experts' comments on the workflow and on its tasks; with a task selected, the ones about it. */
export function WorkflowComments({ data, selected }: { data: TemplateDetail; selected: string }) {
  const comments = (data.workflow_comments ?? []).filter(c => !selected || c.target === selected || c.target === 'template')
  if (!comments.length) return null
  return <section className="box" aria-label="Comments">
    <h2>Comments</h2>
    {comments.map(comment => <article className="science-history" key={comment.entry_id}>
      <p className="small muted">{comment.target === 'template' || !comment.target ? 'Whole workflow' : data.tasks.find(t => t.task_id === comment.target)?.title ?? comment.target}</p>
      <p className="prewrap">{comment.feedback}</p>
      <p className="small muted science-review-byline"><PersonName people={data.people} id={comment.actor.user_id} email={comment.actor.email} fallback="" /><time dateTime={comment.at}>{fmtDateTime(comment.at)}</time></p>
    </article>)}
  </section>
}
